import React from 'react';
import { Table } from 'antd';
import './ProjectTable.scss';

const ProjectTimelineTable = ({ data, columns }) => {
        return (
                <Table
                        columns={columns}
                        dataSource={data}
                        pagination={false}
                        bordered
                        className={`  custom-ant-table`}
                        tableLayout="fixed" // ensures the width values are respected
                />
        );
};

export default ProjectTimelineTable;
